import React, { Component } from 'react';
import { connect } from 'react-redux';
import  Sidebar  from './sidebar';
import  Header  from './header';

class App extends Component {
    componentDidMount(){
        // $('body').on('click', '.dropdown-toggle', function () {
        //     $(this).parent().toggleClass('open')
        // })
    }
    render() {
        // let dev = 'false';
        // if(NODE_ENV == "dev") {
        //     dev = 'true';
        // }
        //         <Breadcrumbs routes={this.props.routes} params={this.props.params} setDocumentTitle={true}/>
        return (
            <div className="container-app">
                <div>
                    {this.props.location.pathname != 'sign_in' ? <Sidebar /> : ''}
                    {this.props.location.pathname != 'sign_in' ? <Header routes={this.props.routes} params={this.props.params}/> : ''}
                    {this.props.children}
                </div>
            </div>
        );
    }
}


export default connect(null, null)(App);


// WEBPACK FOOTER //
// ./src/components/app.js